import { ContentPaste, Lock } from "@mui/icons-material";
import * as yup from "yup";
import { userRoles } from "../../../constants/user";

export const userCreationStepsInfo = [
  { icon: ContentPaste, title: "User Details and Roles" },
  { icon: Lock, title: "Password" },
];

export const userEditStepsInfo = [
  { icon: ContentPaste, title: "User Details and Roles" },
];


export const userCreateInitData = {
  name: "",
  role: "",
  district: "",
  hasReReferPermission: false,
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
};

const userCreationValidationFirstStep = {
  name: yup.string().required("Name is required"),
  role: yup.string().required("Role is required"),
  hasReReferPermission: yup.boolean().required("Referral Permission is required"),
  district: yup
    .string()
    .ensure()
    .when("role", {
      is: userRoles.SURGEON,
      then: yup
        .string()
        .required(
          `District is required for ${userRoles.SURGEON.toLowerCase()}`
        ),
    }),
  email: yup.string().required("Email is required"),
  phone: yup.string().required("Phone is required"),
};

export const userCreationValidationSchema = [
  yup.object().shape({ ...userCreationValidationFirstStep }),
  yup.object().shape({
    ...userCreationValidationFirstStep,
    password: yup.string().required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password")], "Passwords must match")
      .required("Confirm Password is required"),
  }),
];
